<template>
  <div class="section-header">
    <h3>{{ title }}</h3>
  </div>
</template>

<script>
export default {
  name: 'SectionHeader',
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
